import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { put } from "../../../common/api/apiShared.ts";
import { ToggleFrameworkTemplateStatusDialogProps } from "./ToggleFrameworkTemplateStatusDialog.tsx";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

export function useToggleIsPublishedDialog(props: ToggleFrameworkTemplateStatusDialogProps) {
    const snackbar = useDotLegalSnackbar();
    const toggleMutation = useDotLegalMutation(getIsPublishedApi);
    const toggleIsPublished = async () => {
        await toggleMutation.mutateAsync(undefined, {
            onSuccess: () => {
                snackbar.show(!props.isPublished ? "The framework template has been activated" : "The framework template has been deactivated", "success");
                if (props.onToggleSuccess) {
                    props.onToggleSuccess();
                }
            },
        });
    };

    return { toggleIsPublished, isMutatingIsPublished: toggleMutation.isLoading };

    function getIsPublishedApi() {
        return put(`/Frameworks/templates/${props.templateId}/toggleIsPublished`, !props.isPublished);
    }
}
